// ============================================================================
// equipment.fueling.hub — migrated off the global read
// ============================================================================
// The operator fueling hub at /equipment: category clusters of equipment tiles.
// Its single page-local read of `equipment` (16 named columns, status=active,
// ordered by name) moves to the `equipment.fuelingHub.core` catalog resource.
//
// That resource serves TWO surfaces because FuelingHub mounts ONE container for
// both: the form at /equipment/<slug> resolves its machine out of the same
// array. That is still exactly one owner per surface — the catalog lists both in
// `surfaces` and the ledger carries the multiplicity as two distinct
// (surface, resource) pairs.
//
// The third sibling, equipment.fueling.supply, is separately receipt-backed as
// no-server-read: FuelSupplyWebform issues no render read at all, and a
// resource declaring neither a table nor an RPC would be fictitious.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'equipment.fueling.hub',
  obligations: Object.freeze([
    Object.freeze({id: 'equipment.fuelingHub.core', owner: 'permanent'}),
    Object.freeze({id: 'equipment.ownReports', owner: 'permanent'}),
  ]),
  residualLegacy: Object.freeze([]),
});

export default declaration;
